import clsx from "classnames"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig"
import { pageUrl } from "common/lib/router"
import { useTranslations } from "modules/i18n/hooks/useTranslations"

export const DesktopMenu = () => {
  const { navItems, pageSlug, regionCode } = usePageProps<AppProps>()
  const t = useTranslations("layout.header")
  const {
    section_nav: { custom_nav_link: customNavLink },
  } = useRegionConfig()
  const currentPathname = pageUrl.view({ regionCode, pageSlug })
  const isCustomNavLinkActive = currentPathname === customNavLink.link

  return (
    <nav
      className="text-3xs lg:text-2xs hidden font-bold text-black lg:flex 2xl:text-sm"
      data-testid="desktopMenu"
      aria-label={t("sections_nav_label")}
    >
      {navItems
        .sort((navItemA, navItemB) => navItemA.position - navItemB.position)
        .map(({ title, path }) => {
          const isCurrentPage = currentPathname === path
          return (
            <a
              key={path}
              href={path}
              className={clsx(
                "mr-2.5 border-b-4 pt-3 pb-2 font-sans hover:border-red-600 2xl:mr-4",
                {
                  "border-red-600": isCurrentPage,
                  "border-transparent": !isCurrentPage,
                },
              )}
            >
              {title}
            </a>
          )
        })}

      {customNavLink.enabled ? (
        <a
          className={clsx("ml-auto border-b-4 pt-3 pb-2 hover:border-red-600", {
            "border-red-600": isCustomNavLinkActive,
            "border-transparent": !isCustomNavLinkActive,
          })}
          href={customNavLink.link}
        >
          {customNavLink.title}
        </a>
      ) : null}
    </nav>
  )
}
